import { cn } from '@/helpers/common';

const StubJC = ({
  texts,
  elementClassName,
}: {
  elementClassName?: {
    mainClassName?: string;
  };
  texts: { mainText: string; subText?: string };
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center mx-auto max-w-150 text-jc-firefly',
        elementClassName?.mainClassName,
      )}
    >
      <p className="font-semibold max-md:text-xl md:text-3xl text-center text-jc-firefly">
        {texts.mainText}
      </p>
      {texts.subText && (
        <p className="mt-3 max-md:text-base md:text-lg text-center text-jc-trout">
          {texts.subText}
        </p>
      )}
    </div>
  );
};

export default StubJC;
